import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex-auto", _ctx.inline ? 'input-group' : ''])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_Dropdown, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      editable: _ctx.editable,
      options: _ctx.options,
      optionLabel: _ctx.optionLabel,
      optionValue: _ctx.optionValue,
      placeholder: _ctx.placeholder,
      showClear: _ctx.showClear,
      onChange: _ctx.onChange,
      class: "w-full mt-1"
    }, null, 8, ["modelValue", "editable", "options", "optionLabel", "optionValue", "placeholder", "showClear", "onChange"])
  ], 2))
}